'use client';

import { MAP_ID, useNaverMap } from '@/hooks/use-naver-map';
import { cn } from '@/lib/utils';
import { MarkerType } from '@/types/marker.type';

interface Props {
  markers: MarkerType[];
  zoom?: number;
  width?: string;
  height?: string;
  className?: string;
}

export default function MapWithMarkers({
  markers,
  zoom = 15,
  width = '100%',
  height = '386px',
  className,
}: Props) {
  const { containerRef } = useNaverMap({ markers, zoom });

  return (
    <div
      ref={containerRef}
      id={MAP_ID}
      style={{ width, height }}
      className={cn('desktop:h-[338px]', className)}
    />
  );
}
